import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [],
  providers: [],
})
export class ZorroModule {}
